import { FC, useState } from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import { Box } from '@mui/material';
import clsx from 'clsx';

import { ReactComponent as DeleteIcon } from 'assets/icons/DeleteIcon.svg';

import { Button } from 'components/_basic/Button/Button';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';

import { IFieldArrayTabsProps } from './types';
import { AddButton } from '../components/AddButton';

import styles from './FieldArrayTabs.module.scss';

export const FieldArrayTabs: FC<IFieldArrayTabsProps> = ({
  name,
  buttonItemName,
  title,
  buttonText,
  removeButtonText,
  initialItem,
  maxLength = 5,
  fieldArrayStyles,
  children,
  disabled = false,
}) => {
  const { control } = useFormContext();

  const [activeIndex, setActiveIndex] = useState(0);

  const { fields, append, remove } = useFieldArray({ control, name });

  const handleAddRow = () => {
    append(initialItem);
  };

  // TODO: refactor.
  const tabs = useWatch({ name });
  const tabsToDisplay = tabs?.map((item: any) => item[buttonItemName as string]) ?? [];

  const canAddMore = fields.length < maxLength;

  const removeItem = (index: number) => {
    remove(index);

    if (index !== 0) {
      setActiveIndex(index - 1);
    }
  };

  return (
    <Box>
      {/* TODO: MOVE to new component */}
      <FormSectionCard disabled={disabled} title={title} collapsible>
        <Box className={styles.tabsContainer}>
          {tabsToDisplay.map((item: string, index: number) => (
            <Button
              key={index}
              className={clsx(styles.tabsButton, index === activeIndex && styles.tabsButtonActive)}
              onClick={() => setActiveIndex(index)}
              disabled={disabled}
              buttonClassName={styles.tabsButtonContent}
            >
              <span className={styles.buttonContentWrapper}>{item}</span>
            </Button>
          ))}
          <AddButton
            canAddMore={canAddMore}
            onClick={handleAddRow}
            className={fieldArrayStyles?.addButton}
            disabled={disabled}
            variant="text"
          >
            {buttonText}
          </AddButton>
        </Box>
      </FormSectionCard>
      <FormSectionCard disabled={disabled}>
        <Box className={fieldArrayStyles?.container}>
          {fields.map((item, index) => {
            return index === activeIndex ? (
              <Box key={item.id} className={clsx(styles.rowContainer, fieldArrayStyles?.rowContainer)}>
                <Box className={styles.rowChildren}>
                  {!!children && children(`${name}.${index}`, index, () => remove(index))}
                </Box>
                <Box className={styles.removeButtonContainer}>
                  <Button
                    className={clsx(styles.removeButton, fieldArrayStyles?.removeButton)}
                    onClick={() => removeItem(index)}
                    disabled={disabled}
                  >
                    <DeleteIcon />
                    {removeButtonText}
                  </Button>
                </Box>
              </Box>
            ) : null;
          })}
        </Box>
      </FormSectionCard>
    </Box>
  );
};
